/* eslint-disable react-hooks/exhaustive-deps */
import { Image } from '@mui/icons-material';
import { Autocomplete, Button,
  // Chip,
  Grid, Stack, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { getTrainersList as getTeachersList,
  // getAllowedList as getUserLevelList
} from 'src/services';
import { getMedia } from 'src/utils/getImage';

export const CourseTrainer = ({ trainer, setTrainer, error }) => {
  const ref = useRef();

  const [file, setFile] = useState(null);

  const [trainerList, setTrainerList] = useState([]);
  // const [allowedList, setAllowedList] = useState([]);

  const [trainerOpen, setTrainerOpen] = useState(false);
  // const [allowedOpen, setAllowedOpen] = useState(false);

  const [preview, setPreview] = useState('');

  const getTrainersList = async () => {
    try {
      const response = await getTeachersList();
      setTrainerList(response.teachers);
    } catch (error) {
      console.warn(error);
    }
  };
  // const getAllowedList = async () => {
  //   try {
  //     const response = await getUserLevelList();
  //     setAllowedList(response.userLevels);
  //   } catch (error) {
  //     console.warn(error);
  //   }
  // };
  const onUpload = () => {
    if (!file) return;
    setTrainer({ ...trainer, image: file });
    const blob = URL.createObjectURL(file);
    setPreview(blob);
  };

  useEffect(() => {
    onUpload();
  }, [file]);

  // const accessDesc = 'افرادی که قادر به مشاهده دوره هستند* ';

  useEffect(() => {
    if (preview !== '') setPreview(file);
  }, []);
  return (
    <Grid container spacing={3} sx={{ my: 'auto' }}>
      <Grid item xs={12}>
        <Autocomplete
          options={trainerList}
          getOptionLabel={(option) => option.name || ''}
          open={trainerOpen}
          onOpen={() => {
            getTrainersList();
            setTrainerOpen(true);
          }}
          onClose={() => setTrainerOpen(false)}
          value={trainer.trainer?._id ? trainer.trainer : null}
          onChange={(e, newValue) => setTrainer({ ...trainer, trainer: newValue })}
          renderInput={(params) => (
            <TextField {...params} label="مدرس" fullWidth error={error && trainer.trainer?._id === undefined} />
          )}
          disableClearable
        />
      </Grid>
      {/*<Grid item xs={12}>*/}
      {/*  <Autocomplete*/}
      {/*    options={allowedList}*/}
      {/*    getOptionLabel={(option) => option.levelName || ''}*/}
      {/*    getOptionKey={(option) => option._id}*/}
      {/*    open={allowedOpen}*/}
      {/*    onOpen={() => {*/}
      {/*      getAllowedList();*/}
      {/*      setAllowedOpen(true);*/}
      {/*    }}*/}
      {/*    onClose={() => setAllowedOpen(false)}*/}
      {/*    value={trainer.allowed?._id ? trainer.allowed : null}*/}
      {/*    onChange={(e, newValue) => setTrainer({ ...trainer, allowed: newValue })}*/}
      {/*    renderInput={(params) => (*/}
      {/*      <TextField*/}
      {/*        {...params}*/}
      {/*        label="حداقل سطح دسترسی"*/}
      {/*        fullWidth*/}
      {/*        helperText={accessDesc}*/}
      {/*        error={error && trainer.allowed?._id === undefined}*/}
      {/*        autoComplete="off"*/}
      {/*      />*/}
      {/*    )}*/}
      {/*    renderTags={(value, getTagProps) =>*/}
      {/*      value.map((option, index) => {*/}
      {/*        const { key, ...tagProps } = getTagProps({ index });*/}
      {/*        return (*/}
      {/*          <Chip key={key} variant="outlined" label={option.name} color="primary" size="medium" {...tagProps} />*/}
      {/*        );*/}
      {/*      })*/}
      {/*    }*/}
      {/*    disableClearable*/}
      {/*  />*/}
      {/*</Grid>*/}
      <Grid item lg={6} xs={12}>
        <Stack
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 300,
            border: `1px dashed ${error && trainer.image === '' ? '#FF4842' : '#774c9e80'}`,
          }}
        >
          <Button variant="contained" size="large" endIcon={<Image />} onClick={() => ref.current.click()}>
            آپلود تصویر دوره
          </Button>
          {typeof trainer.image === 'string' && (
            <img src={getMedia(trainer.image)} alt="" style={{ maxWidth: 200, maxHeight: 200, marginTop: '1rem' }} />
          )}
          {preview !== '' && <img src={preview} alt="" style={{ maxWidth: 200, maxHeight: 200, marginTop: '1rem' }} />}
          <input
            type="file"
            ref={ref}
            hidden
            accept="image/*"
            onChange={(e) => setFile(e.target.files[0])}
            onClick={(e) => (e.currentTarget.value = null)}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
